<div class="credit-card-form-container d-flex flex-column align-self-center">
    @if (isLoadingForm) {
        <ng-container *ngTemplateOutlet="isLoadingFormTemplate" />
    }
    @if (processorName) {
        @if (addPersonalForm) {
            <div #personalInfoForm class="credit-card-body">
                <app-form-personal (personalFormValueChanges)="creditCardFormGroupChange($event)" />
            </div>
        }
        <lib-adyen-advanced
            [totalAmount]="0"
            [emailUser]="isGuest ? emailUser : ''"
            [personalFormStatus]="isGuest ? isPersonalFormValid : true"
            [displayCancelButton]="true"
            [displayAdyenPayButton]="false"
            [isGuest]="isGuest"
            (responseAdyen)="responseAdyen($event)"
        />
    }
    <ng-template #isLoadingFormTemplate>
        <section class="content d-flex justify-content-center align-items-center">
            <mat-spinner class="loading-form" diameter="36" />
        </section>
    </ng-template>
</div>
